import { Visibility } from '@mui/icons-material'
import { IconButton } from '@mui/material'

interface ViewActionButtonProps {
  onClick: () => void
}

const ViewActionButton = ({ onClick }: ViewActionButtonProps) => {
  return (
    <IconButton color={'primary'} aria-label="View" onClick={onClick}>
      <Visibility />
    </IconButton>
  )
}

export default ViewActionButton
